/**
 * `ide.schedule.open` — open the Agendamentos pane (agendamentos plan P3 /
 * R2 handoff §3.4; contract frozen by P0 ruling 5: name `ide.schedule.open`,
 * target `ide_client`, params `{jobId?}`, IM-gated OFF like its siblings).
 *
 * Navigation-only, never a mutation — the same discipline as the contacts
 * nav ops. `/schedule` is the route ENTRY that opens the focus pane (the pane
 * has no URL of its own), so this handler navigates and lets `ScheduleLayout`
 * do the pane work.
 *
 * ⚠ The RUNTIME half ships from the recurring-jobs lane. Registering the
 * receiving end early is safe and inert — an op nobody emits simply never
 * fires — and it means the concierge's "abre meus agendamentos" works the
 * moment their roll lands, with no second SPA deploy.
 *
 * `jobId` is accepted per the contract and carried as `?job=<id>` so a future
 * deep-link can focus one row; the pane ignores it today rather than
 * pretending to scroll somewhere it cannot yet.
 */
import type { Handler } from "@/lib/platform-ops-registry";
import { navigateTo } from "@/lib/navigation-bridge";

export const ideScheduleOpenHandler: Handler = (raw) => {
  const jobId = (raw as { jobId?: unknown }).jobId;
  const suffix =
    typeof jobId === "string" && jobId.trim().length > 0
      ? `?job=${encodeURIComponent(jobId.trim())}`
      : "";
  const ok = navigateTo(`/schedule${suffix}`);
  return ok
    ? { ok: true, data: { path: `/schedule${suffix}` } }
    : {
        ok: false,
        error: { code: "IDE_NAV_UNAVAILABLE", message: "Router not mounted yet." },
      };
};
